import {
  ISubmitFormRequest,
  ISubmitFormResponse
} from "../../modules/EmployeeTaxForms/types";
import { requestForms } from "../serviceForms";

export const submit = async (
  formInstanceId: string,
  request: ISubmitFormRequest,
  idempotencyKey: string
): Promise<ISubmitFormResponse> =>
  requestForms<ISubmitFormResponse>({
    method: "POST",
    path: `/${formInstanceId}/schema/submit`,
    body: {
      data: request.data,
      // V3 stamps signer identity, timestamp, IP and user agent server-side
      // from the authenticated request; the client supplies ONLY consent.
      signature: { consentAccepted: request.signature.consentAccepted }
    },
    // Forwarded verbatim — the forms service is the idempotency authority.
    headers: { "Idempotency-Key": idempotencyKey }
  });
